import React, { useEffect } from 'react'
import moment from 'moment'
import './styles/ChannelMessages.css'
import { Toast } from 'antd-mobile'
import BotMessage from './BotMessage'
import { extractDocumentsFromText } from '../../utils/common'
import { BOT_USER_ID, BOT_USER_NAME } from '../../utils/constant'

function renderMessageContent(msg, searchQuery) {
  let text = msg.msg
  if (msg.mentions) {
    msg.mentions.forEach(mention => {
      text = text.replaceAll(
        `@${mention.username}`,
        `<span class='mention'>@${mention.name}</span>`
      )
    })
  }
  if (searchQuery) {
    const regex = new RegExp(
      `(${searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'gi'
    )
    text = text.replace(regex, '<mark>$1</mark>')
  }
  return text
}

function SearchResults({
  searchResults,
  handleSearchResultClick,
  searchQuery,
  searchLoading
}) {

  useEffect(() => {
    if (!searchLoading && searchResults.length === 0 && searchQuery) {
      Toast.show({
        content: 'No messages found.',
        duration: 2000
      })
    }
  }, [searchLoading, searchResults.length, searchQuery])

  return (
    <div className="channel-messages-wrapper">
      {searchLoading ? (
        <div className="search-loading"></div>
      ) : searchResults.length === 0 ? (
        null
      ) : (
        searchResults.map(msg => {
          let text = msg.msg
          const { documents, text: cleanedText } = extractDocumentsFromText(text)
          const isNewFormat = cleanedText !== text
          text = cleanedText
          const fullBotResponse = msg.msg

          if (documents.length === 0 && msg.mentions) {
            msg.mentions.forEach(mention => {
              text = text.replaceAll(
                `@${mention.username}`,
                `<span class='mention'>@${mention.name}</span>`
              )
            })
          }

          let sender = msg.u?.name || msg.u?.username
          if (msg.u?.username === BOT_USER_ID) {
            sender = BOT_USER_NAME
          }

          return (
            <div
              key={msg._id}
              className="message-container search-result-item"
              onClick={() => handleSearchResultClick(msg._id)}
            >
              <div className="message-header">
                <span className="message-sender">
                  {sender}
                </span>
                <span className="message-timestamp">
                  {moment(msg.ts).format('MMM DD, YYYY h:mm A')}
                </span>{' '}
              </div>
              {documents.length > 0 ? (
                <BotMessage
                  documents={documents}
                  explanation={isNewFormat ? text : undefined}
                  messageId={msg._id}
                  botResponse={fullBotResponse}
                  query=""
                  role={1}
                  personId={null}
                  roomId={msg.rid}
                  feedbacks={[]}
                  showFeedback={false}
                />
              ) : (
                <div
                  className="message-content"
                  dangerouslySetInnerHTML={{
                    __html: renderMessageContent({ ...msg, msg: text }, searchQuery)
                  }}
                />
              )}
            </div>
          )
        })
      )}
    </div>
  )
}

export default SearchResults
